import { Link } from "react-router-dom";
import { img } from "../../lib/api";
import { useSite } from "../../lib/site";
import { StyledText } from "./StyledText";
import { SiteIcon } from "./SiteIcon";

// Inline brand marks so each social network has its real logo rather than a
// generic lucide fallback (`@`, camera, music note…). Each component renders
// as `currentColor` so Tailwind hover classes tint them consistently.
const Svg = ({ size, children }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">{children}</svg>
);
const BrandX = ({ size = 17 }) => <Svg size={size}><path d="M18.244 2H21.5l-7.09 8.106L22.75 22H16.17l-5.146-6.73L5.17 22H1.912l7.584-8.671L1.5 2h6.747l4.65 6.147Zm-1.144 18h1.82L7.0 4H5.08l12.02 16Z"/></Svg>;
const BrandFacebook = ({ size = 17 }) => <Svg size={size}><path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.51 1.49-3.9 3.78-3.9 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.45 2.9h-2.33v6.99A10 10 0 0 0 22 12Z"/></Svg>;
const BrandInstagram = ({ size = 17 }) => <Svg size={size}><path d="M12 2.2c3.2 0 3.584.012 4.85.07 1.17.054 1.805.249 2.228.413.56.218.96.479 1.38.9.42.42.682.819.9 1.38.164.422.359 1.058.413 2.228.058 1.266.07 1.646.07 4.85 0 3.204-.012 3.584-.07 4.85-.054 1.17-.249 1.805-.413 2.228a3.72 3.72 0 0 1-.9 1.38 3.72 3.72 0 0 1-1.38.9c-.422.164-1.058.359-2.228.413-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.054-1.805-.249-2.228-.413a3.72 3.72 0 0 1-1.38-.9 3.72 3.72 0 0 1-.9-1.38c-.164-.422-.359-1.058-.413-2.228C2.212 15.584 2.2 15.204 2.2 12s.012-3.584.07-4.85c.054-1.17.249-1.805.413-2.228.218-.56.479-.96.9-1.38.42-.42.819-.682 1.38-.9.422-.164 1.058-.359 2.228-.413C8.416 2.212 8.796 2.2 12 2.2Zm0 1.8c-3.15 0-3.519.012-4.76.068-1.14.052-1.76.242-2.17.402-.546.212-.936.465-1.346.875-.41.41-.663.8-.875 1.345-.16.41-.35 1.03-.402 2.17C2.212 10.481 2.2 10.85 2.2 14s.012 3.519.068 4.76c.052 1.14.242 1.76.402 2.17.212.546.465.936.875 1.346.41.41.8.663 1.345.875.41.16 1.03.35 2.17.402 1.241.056 1.61.068 4.76.068s3.519-.012 4.76-.068c1.14-.052 1.76-.242 2.17-.402.546-.212.936-.465 1.346-.875.41-.41.663-.8.875-1.345.16-.41.35-1.03.402-2.17.056-1.241.068-1.61.068-4.76s-.012-3.519-.068-4.76c-.052-1.14-.242-1.76-.402-2.17a3.63 3.63 0 0 0-.875-1.345 3.63 3.63 0 0 0-1.345-.875c-.41-.16-1.03-.35-2.17-.402C15.519 4.212 15.15 4.2 12 4.2Zm0 3.15a4.65 4.65 0 1 1 0 9.3 4.65 4.65 0 0 1 0-9.3Zm0 1.8a2.85 2.85 0 1 0 0 5.7 2.85 2.85 0 0 0 0-5.7Zm4.86-2.19a1.09 1.09 0 1 1 0 2.18 1.09 1.09 0 0 1 0-2.18Z"/></Svg>;
const BrandYouTube = ({ size = 17 }) => <Svg size={size}><path d="M23.498 6.186a2.998 2.998 0 0 0-2.111-2.12C19.52 3.5 12 3.5 12 3.5s-7.52 0-9.387.566A2.998 2.998 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a2.998 2.998 0 0 0 2.111 2.12C4.48 20.5 12 20.5 12 20.5s7.52 0 9.387-.566a2.998 2.998 0 0 0 2.111-2.12C24 15.93 24 12 24 12s0-3.93-.502-5.814ZM9.75 15.568V8.432L15.818 12 9.75 15.568Z"/></Svg>;
const BrandLinkedIn = ({ size = 17 }) => <Svg size={size}><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.063 2.063 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></Svg>;
const BrandTikTok = ({ size = 17 }) => <Svg size={size}><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1Z"/></Svg>;

export function SiteLoader({ name = "Olgu Tansuğ" }) {
  return (
    <div className="site-loader" data-testid="site-loader">
      <div className="site-loader__inner">
        <div className="site-loader__mark">{name}</div>
        <div className="site-loader__bar"><span /></div>
      </div>
    </div>
  );
}

export function MaintenanceScreen({ title, text, name = "Olgu Tansuğ" }) {
  return (
    <div className="site-loader" data-testid="maintenance-screen">
      <div className="site-loader__inner max-w-xl px-6" style={{ textAlign: "center" }}>
        <div className="site-loader__mark" style={{ animation: "loaderShine 2.4s linear infinite" }}>{name}</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-white mt-3" data-testid="maintenance-title">{title || "Pek Yakında"}</h1>
        <p className="text-white/70 mt-3 text-base leading-relaxed" data-testid="maintenance-text">{text || "Sitemiz kısa süre içinde yeniden yayında olacak. İlginiz için teşekkürler."}</p>
      </div>
    </div>
  );
}

export function SmartLink({ to, newTab, className, children, ...rest }) {
  if (!to) return <span className={className} {...rest}>{children}</span>;
  if (/^(https?:|mailto:|tel:)/.test(to) || newTab)
    return <a href={to} target={newTab || /^https?:/.test(to) ? "_blank" : undefined} rel="noopener noreferrer" className={className} {...rest}>{children}</a>;
  return <Link to={to} className={className} {...rest}>{children}</Link>;
}

const ICONS = { x: BrandX, instagram: BrandInstagram, facebook: BrandFacebook, youtube: BrandYouTube, linkedin: BrandLinkedIn, tiktok: BrandTikTok };

const linkCls = "w-10 h-10 rounded-full border border-site-border flex items-center justify-center text-s-text hover:bg-s-primary hover:text-s-onprimary hover:border-transparent transition-colors duration-300";

export function Socials({ socials = {}, className = "" }) {
  const { site } = useSite();
  const extra = (site.profile?.socials_links || []).filter((x) => x.url);
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {Object.entries(ICONS).filter(([k]) => socials[k]).map(([k, Icon]) => (
        <a key={k} href={socials[k]} target="_blank" rel="noopener noreferrer" aria-label={k} data-testid={`social-link-${k}`}
          className={linkCls}>
          <Icon size={17} />
        </a>
      ))}
      {extra.map((x, i) => (
        <a key={`c${i}`} href={x.url} target="_blank" rel="noopener noreferrer" aria-label={x.label} title={x.label} data-testid={`social-link-custom-${i}`} className={linkCls}>
          <SiteIcon name={x.icon || "link"} size={17} strokeWidth={1.8} />
        </a>
      ))}
    </div>
  );
}

export function Img({ src, alt, className = "", ...rest }) {
  if (!src) return <div className={`bg-s-border ${className}`} aria-hidden />;
  return <img src={img(src)} alt={alt || ""} loading="lazy" decoding="async" className={className} {...rest} />;
}

export function SectionHead({ eyebrow, title, action }) {
  const { site } = useSite();
  return (
    <div className="flex items-end justify-between gap-6 mb-10 sm:mb-14">
      <div className="flex-1 min-w-0">
        {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
        <StyledText as="h2" className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight" style={site.profile?.section_style} text={title} />
      </div>
      {action}
    </div>
  );
}

/**
 * Standardized hero header for all "Çalışmalarım" pages.
 * - Eyebrow row with gold hairline
 * - Big primary title (line 1)
 * - Optional smaller subtitle (line 2) — 55% the primary size
 * - Right under: social share bar
 * - Thin gold divider finishes the block
 */
export function WorksPageHeader({ eyebrow, title, subtitle, share, backLink = null }) {
  return (
    <div className="rise">
      {backLink}
      <div className="flex items-center gap-4 mb-6" aria-hidden>
        <span className="h-px w-10 bg-s-primary" />
        <span className="eyebrow">{eyebrow}</span>
        <span className="h-px flex-1 bg-white/10" />
      </div>
      <h1
        className="font-heading font-bold tracking-tight text-balance text-4xl sm:text-5xl lg:text-6xl leading-[1.02]"
        data-testid="page-title"
        style={{ color: "#fff" }}
      >
        {title}
      </h1>
      {subtitle && (
        <p
          className="mt-2 font-heading text-xl sm:text-2xl lg:text-[1.75rem] leading-snug tracking-tight text-white/70"
          data-testid="page-subtitle"
        >
          {subtitle}
        </p>
      )}
      {share && (
        <div className="mt-6 flex items-center gap-4">
          {share}
        </div>
      )}
      <div className="mt-7 h-px w-full" style={{ background: "linear-gradient(90deg, rgba(212,175,55,0.6), rgba(212,175,55,0.08) 60%, transparent)" }} aria-hidden />
    </div>
  );
}
